import { type ReactNode } from 'react'

interface LandingDetailHeroProps {
  badge: string
  title: string
  subtitle: string
  highlights: string[]
  visual: ReactNode
}

export function LandingDetailHero({
  badge,
  title,
  subtitle,
  highlights,
  visual,
}: LandingDetailHeroProps) {
  return (
    <section className="mx-auto grid w-full max-w-7xl gap-10 px-4 pt-16 pb-12 sm:px-6 lg:grid-cols-[1.02fr_0.98fr] lg:px-8 lg:pt-20 lg:pb-14">
      <div>
        <span className="inline-flex items-center rounded-full bg-badge px-3 py-1 text-xs font-medium text-badge-foreground ring-1 ring-badge-ring">
          {badge}
        </span>
        <h1 className="m-0 mt-5 max-w-3xl text-4xl leading-tight font-semibold tracking-tight text-foreground sm:text-5xl">
          {title}
        </h1>
        <p className="mt-4 max-w-2xl text-base leading-7 text-muted-foreground sm:text-lg">
          {subtitle}
        </p>

        <ul className="mt-6 grid gap-2.5 pl-0">
          {highlights.map((item) => (
            <li
              key={item}
              className="flex items-start gap-3 rounded-xl bg-glass-inner px-3.5 py-2.5 list-none ring-1 ring-glass-ring-inner"
            >
              <span className="mt-2 h-1 w-1 shrink-0 rounded-full bg-primary" />
              <span className="text-sm text-foreground/90">{item}</span>
            </li>
          ))}
        </ul>
      </div>

      <div>{visual}</div>
    </section>
  )
}
